import {actionIds, BaseAction} from "../common";

const getWarehouseListAction: (data?: any) =>
    BaseAction = (data) => ({
    type: actionIds.GET_WAREHOUSE_LIST,
    payload: {...data},
});

export default getWarehouseListAction;
